import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useAuth } from '../../context/Auth/AuthContext'
import { useCart } from '../../context/Cart/CartContext'
import { useConfig } from '../../context/Config/ConfigContext'
import ItemDetail from '../../components/ItemDetail/ItemDetail'
import { api } from '../../services/api'
import { getSizesByColor, normalizeProduct } from '../../utils/auxFunc'
import Spinner from '../Spinner'
// import { productList } from "../../assets/products";

function ItemDetailContainer() {
  const [product, setProduct] = useState()
  const [productsToAdd, setProductsToAdd] = useState(null)
  const [componentColor, setComponentColor] = useState()
  const [showSpinner, setShowSpinner] = useState(true)
  const [changeImgInEachColor, setChangeImgInEachColor] = useState({
    img: ''
  })
  const [imgIndex, setImgIndex] = useState(0)
  const { idProduct } = useParams()
  const { throttle } = useConfig()
  const { addToCart, cart } = useCart()
  const { auth, userData } = useAuth()
  console.log({ productsToAdd })
  const getInitialValue = (id) => {
    const componentToAdd = productsToAdd?.components.find(
      (component) => component.idComponent === id
    )
    const initial = componentToAdd?.quantity
    return initial
  }

  const largerStockComponent = useCallback((components) => {
    let stocks = []
    components?.forEach(({ types }) => {
      stocks.push(types.reduce((acc, { stock }) => acc + stock, 0))
    })

    const largerStockIndex = stocks.findIndex(
      (stock) => stock === Math.max(...stocks)
    )

    return components[largerStockIndex]
  }, [])

  const handleProductsToAddToCart = (id, quantity) => {
    let productToAddAux = JSON.parse(JSON.stringify(productsToAdd))
    // let productToAddAux = productList.find(el=>el.idProduct === parseInt(idProduct));

    if (quantity === 0) {
      const componentsUpdated = productToAddAux.components?.filter(
        (component) => component.idComponent !== id
      )
      productToAddAux.components = componentsUpdated
    }
    if (
      productToAddAux.components?.some(
        (component) => component.idComponent === id
      )
    ) {
      productToAddAux.components.find(
        (component) => component.idComponent === id
      ).quantity = quantity
    } else {
      const componentToAdd = product.components.find(
        (component) => component.idComponent === id
      )
      componentToAdd.quantity = quantity
      productToAddAux.components = [
        ...productToAddAux.components,
        componentToAdd
      ]
    }

    let stockProduct = productToAddAux.components.find(
      (component) => component.idComponent === id
    ).stock

    if (
      productToAddAux.components.find(
        (component) => component.idComponent === id
      ).quantity === stockProduct
    ) {
      Swal.fire({
        customClass: {
          confirmButton: 'swalBtnOk',
          title: 'swalTitle'
        },
        position: 'left',
        icon: 'warning',
        title: 'Límite de Stock',
        text:
          'Llegaste a la cantidad máxima disponible para éste producto. Stock:' +
          ' ' +
          `${stockProduct}` +
          ' ' +
          'unidades',
        width: '350px',
        showConfirmButton: true,
        focusConfirm: false,
        iconColor: 'rgb(230, 11, 19)',
        color: '#292929',
        background: '#FAFAFA',
        confirmButtonColor: 'rgb(230, 11, 19)'
      })
    }

    setProductsToAdd(productToAddAux)
  }

  const handleAddToCart = () => {
    const productsToAdd = removeComponentsZeroQuantity()

    try {
      if (productsToAdd.components.length > 0) {
        addToCart(productsToAdd)
        setProductsToAdd(product)
      }
    } catch (error) {
      Swal.fire({
        customClass: {
          confirmButton: 'swalBtnOk',
          title: 'swalTitle'
        },
        position: 'left',
        icon: 'warning',
        title: 'Error',
        text: 'No selecciono cantidad de ningún producto',
        width: '350px',
        showConfirmButton: true,
        focusConfirm: false,
        iconColor: 'rgb(230, 11, 19)',
        color: '#292929',
        background: '#FAFAFA',
        confirmButtonColor: 'rgb(230, 11, 19)'
      })
    }
  }

  const sizesByColor = getSizesByColor(product)

  function handleClickColor(color) {
    //setea el array de colores, y el objeto que coincida con el color presionado lo trae
    //para luego mapearlo y arrojar las medidas, con sus stocks.
    setChangeImgInEachColor({ img: '' })
    setComponentColor(
      sizesByColor.find(
        (colorComponent) => colorComponent.descriptionColor === color
      )
    )
  }

  function handleChangeImg(num) {
    setImgIndex(num)
    setChangeImgInEachColor(componentColor?.imgC[num])
  }

  const getQuantityByColor = (color) => {
    let componentsByColor = cart
      ?.find((element) => element.idProduct === product.idProduct)
      ?.components.filter((component) => component.descriptionColor === color)
    if (componentsByColor && color === componentsByColor[0]?.descriptionColor) {
      return componentsByColor.reduce((acc, { quantity }) => acc + quantity, 0)
    }
  }

  const sameQuantityAsCart = () => {
    let prodInCart = cart?.find(
      (product) => product.idProduct === parseInt(idProduct)
    )

    return productsToAdd.components?.every((component) => {
      const compInCart = prodInCart?.components.find((el) => {
        return el.idComponent === component.idComponent
      })

      return !compInCart
        ? component.quantity === 0
        : component.quantity === compInCart.quantity
    })
  }

  const removeComponentsZeroQuantity = () => {
    let productToAddAux = JSON.parse(JSON.stringify(productsToAdd))
    const componentsWithQuantity = productToAddAux.components?.filter(
      (component) => component.quantity !== 0
    )
    productToAddAux.components = componentsWithQuantity

    return productToAddAux
  }

  const isDisabled = productsToAdd && sameQuantityAsCart()
  const getProductById = useCallback(
    (idC, idP) => {
      api.products
        .listById(idC, idP)
        .then((response) => response.json())
        .then((productAPI) => {
          const productNormalized = normalizeProduct(productAPI)
          productNormalized.components.map(
            (component) => (component.quantity = 0)
          )
          const prodToAdd = productNormalized

          const productInCart = cart?.find(
            (element) => element.idProduct === parseInt(idProduct)
          )

          if (productInCart) {
            productInCart.components.forEach((element) => {
              prodToAdd.components.forEach((component) => {
                const componentInCart =
                  component.idComponent === element.idComponent && element

                if (componentInCart) {
                  component.quantity = componentInCart.quantity
                }
              })
            })
          } else {
            prodToAdd.components.forEach(
              (component) => (component.quantity = 0)
            )
          }
          setProductsToAdd(prodToAdd)
          setProduct(productNormalized)
          // setProduct(productList.find(el=> el.idProduct === parseInt(idProduct)));
        })
        .catch((err) => {
          // return Swal.fire({
          // 	title: "Error!",
          // 	text: `Producto sin stock`,
          // 	icon: "error",
          // });
        })
        .finally(() => setShowSpinner(false))
    },
    [cart, idProduct]
  )

  useEffect(() => {
    !product && getProductById(userData.clientPriceListId, parseInt(idProduct))

    if (product?.idProduct !== parseInt(idProduct))
      getProductById(userData.clientPriceListId, parseInt(idProduct))

    product &&
      setComponentColor(largerStockComponent(getSizesByColor(product)) || [])
    window.scrollTo(0, 0)

    return () => {
      if (parseInt(idProduct) !== product?.idProduct && product !== null)
        getProductById(userData.clientPriceListId, parseInt(idProduct))
    }
  }, [
    cart,
    getProductById,
    idProduct,
    largerStockComponent,
    product,
    userData.clientPriceListId
  ])

  return showSpinner ? (
    <Spinner />
  ) : (
    <ItemDetail
      throttle={throttle}
      showPriceAndLogin={!!auth}
      getInitialValue={getInitialValue}
      handleProductsToAddToCart={handleProductsToAddToCart}
      handleAddToCart={handleAddToCart}
      product={product}
      sizesByColor={sizesByColor}
      handleClickColor={handleClickColor}
      componentColor={componentColor}
      isDisabled={isDisabled}
      getQuantityByColor={getQuantityByColor}
      handleChangeImg={handleChangeImg}
      changeImgInEachColor={changeImgInEachColor}
      imgIndex={imgIndex}
    />
  )
}

export default ItemDetailContainer
